import React from "react";
import FeaturedOneWayConfigContent from "../components/featured-one-way/featured-one-way-config-content";

const FeaturedOneWayConfig = () => {
  return <FeaturedOneWayConfigContent />;
};

export default FeaturedOneWayConfig;
